import React, { useEffect, useState, useContext } from "react";
import TruncatedPages from "./TruncatedPages"; // eslint-disable-line
import { useMediaQuery } from "react-responsive";
import Context from "../Products/ProductsProvider";
import { handleDecrementPage, handleIncrementPage } from "./actions/paginationActions";

import { Sizes } from "../../styles";

/*
 ** Station for pagination
 */

const Pagination = () => {
	const {
		data: { params, totalPages, items},
		actions: { setParams},
	} = useContext(Context);

	const [truncatedPages, setTruncatedPages] = useState([]);

	const isDesktopOrLaptop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});

	const formattedPagesArray = (pagesArray, currentPage, displayedPages) => {
		const currentPageInteger = parseInt(currentPage);
		
		if (pagesArray.length === 0 || !currentPageInteger) return [];

		if (pagesArray.length <= displayedPages + 3) return pagesArray;

		const pagesCopy = [...pagesArray];

		if (currentPageInteger < displayedPages + 2 && pagesArray.length > displayedPages) { 
			return [...pagesCopy.toSpliced(displayedPages + 2), '...', pagesCopy[pagesCopy.length - 1]];
		}

		if (currentPageInteger > pagesCopy[pagesCopy.length - (displayedPages + 2)] && pagesArray.length > displayedPages) { 
			return [pagesCopy[0], '...', ...pagesCopy.slice(-displayedPages - 2)];
		}

		if (currentPageInteger >= (displayedPages + 2) && currentPageInteger <= pagesCopy[pagesCopy.length - (displayedPages + 2)]) { 
			return [pagesCopy[0], '...', ...pagesCopy.slice(currentPageInteger - 2, currentPageInteger + 1), '...', pagesCopy[pagesCopy.length - 1]];
		}		
	}
	
	const displayedPages = isDesktopOrLaptop ? 3 : 2;

	useEffect(() => {
		setTruncatedPages(formattedPagesArray(totalPages, params.get("pageNumber"), displayedPages));
	}, [totalPages, params.get("pageNumber")]);

	if (items.length > 0) return (
		<div className="pagination-react">
			<div className="pagination-react__wrapper">
				<a
					href=""
					className={`prev${params.get("pageNumber") === 1 ? " disable" : ""}`}
					onClick={(event) => {
						handleDecrementPage(parseInt(params.get("pageNumber")), setParams, event);
					}}
					aria-label="go to previous page"
				></a>
				<TruncatedPages
					truncatedPages={truncatedPages}
				/>
				<a
					href=""
					className={`next ${
						params.get("pageNumber") === totalPages.length ? " disable" : ""
					}`}
					onClick={(event) => {
						handleIncrementPage(parseInt(params.get("pageNumber")), setParams, totalPages, event);
					}}
					aria-label="go to next page"
				></a>
			</div>
		</div>
	);
};

export default Pagination;
